module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs_dhx_material/tree_arrow.svg?628b6dea0dc1375bce97bd1f78b5ef72";